const spellType = ['Charm', 'Conjuration', 'Transfiguration', 'DarkCharm', 'Spell', 'HealingSpell', 'Jinx', 'Curse', 'MagicalTransportation', 'Hex', 'CounterSpell', 'DarkArts', 'CounterJinx', 'CounterCharm', 'None', 'Untransfiguration', 'BindingMagicalContract', 'Vanishment']
const elixirsDifficulty = ['Unknown', 'Advanced', 'Moderate', 'Beginner', 'OrdinaryWizardingLevel', 'OneOfAKind']
const elixirsIngredient = ['Neem oil', 'Jewelweed', 'Onion juice', "Nagini's venom", 'Unicorn blood', 'Frog brains', 'Beetle Eyes', 'Powdered graphorn horn', 'Chizpurfle carapaces', 'Fire Seeds', 'Billywig stings', 'Scarab beetles', 'Fanged Geranium', 'Chinese Chomping Cabbage', 'Arm bone', 'Red spider', 'Puffer-fish', 'Cheese', 'Snake fangs', 'Stewed Mandrake', 'Toasted dragonfly thoraxes', 'Flying Seahorses', 'Rat spleens', 'Dragon dung', 'Sloth brain', 'Petroleum Jelly', 'Asian Dragon Hair', 'Gomas Barbadensis', 'Newt spleens', 'Orange snake', 'Bananas', 'Green leaf', 'Murtlap tentacle', 'Dragonfly thoraxes', 'Fairy wings', 'Doxy eggs', 'Flobberworm Mucus', 'Lionfish spines', 'Horklump juice', 'Standard Ingredient', 'Powdered Porcupine quills', 'Powdered Unicorn horn', 'Valerian root', 'Powdered moonstone', 'Syrup of Hellebore', 'Dogbane', 'Alihotsy', 'Porcupine quills', 'Rat tails', 'Armadillo bile', 'Aconite', 'Armotentia', 'Water', 'Bat wings', 'Wormwood', 'Acromantula venom', 'Dragon claw', 'Essence of Venomous Tentacula', 'Powdered Lionfish', 'Salamander blood', 'Powdered Griffin claw', 'Sneezewort', 'Honeywater', 'Scurvy grass', 'Vervain infusion', 'Peacock feathers', 'Eagle owl feather', 'Giant Purple Toad warts', 'Death-Cap', 'Pearl Dust', 'Galanthus Nivalis', 'Jobberknoll feathers', 'Powdered Sage', 'Extract of Gurdyroot', 'Castor oil', 'Wiggentree twigs', 'Crocodile heart', 'Peppermint', 'Lavender', 'Wolfsbane', 'Boom Berry juice', 'Moondew', 'Chizpurfle fangs', 'Unicorn horn', 'Billywig sting slime', 'Wiggentree bark', 'Mint', 'Sloth brain Mucus', 'Moly', 'Dittany', 'Infusion of Wormwood', 'Alihotsy leaves', 'Dried billywig stings', 'Lovage', 'Exploding Fluid', 'Erumpent horn', 'Erumpent tail', 'Chicken', 'Spiders', 'Cherries', 'Sliced caterpillars', 'Peeled Shrivelfig', 'Minced daisy roots', 'Leech juice', 'Cowbane', 'Ground scarab beetles', 'Ginger roots', 'Octopus Powder', 'Flower head', 'Powdered Root of Asphodel', 'Sopophorous bean', "Angel's Trumpet", 'Mint sprigs', 'Puffer-fish eyes', 'Dried nettles', 'Bat spleens', 'Bursting mushrooms', 'Wartcap powder', 'Fungi', 'Shrivelfig', 'Baneberry', 'Lethe River Water', 'Mistletoe berry', 'Valerian sprigs', 'Shrake spines', 'Horned slugs', 'Pungous Onions', 'Bone of the father', 'Flesh of a servant', 'Blood of a foe', 'Bicorn horn', 'Mandrake Root', 'Granian hair', 'Snowdrop', 'Bitter root', "Re'em blood", 'Syrup of Arnica', 'Rose Petals', 'Ashwinder egg', 'Rose thorns', 'Bezoar', 'Runespoor eggs', 'Powdered dragon claw', 'Leaping Toadstools', 'Bubotuber Pus', 'Gravy', 'Unidentified blue powder', 'Ground Unicorn horn', 'Monkshood', 'Bloodroot', 'Foxglove', 'Flitterby Moth', 'Bouncing Bulb', 'Star Grass', 'Frog parts', 'Lacewing flies', 'Leeches', 'A bit of the person one wants to turn into', 'Powdered bicorn horn', 'Boomslang skin', 'Fluxweed', 'Knotgrass', 'Avocado skin', 'Kneazle hair', 'Gurdyroot', 'Moonseed', 'Abraxan hair', 'Dragon liver', 'Bundimun Ooze', 'Streeler shells', 'Tormentil tincture', 'Hemlock essence', 'Cowbane essence', "Lady's Mantle", 'Unicorn hair', 'Morning dew', 'Powdered Asphodel petals', 'Nettle essence', 'Agrimonia', 'Ice pop', 'Flowers', 'Tincture of thyme', 'Occamy eggshell', 'Powdered common rue', 'Squill bulb', 'Butterscotch', 'Hermit crab shell']
const elixirsInventor = ['Linfred of Stinchcombe', 'Fleamont Potter', 'Fred Weasley', 'George Weasley', 'null Dr Ubbly', 'Tilden Toots', 'Zygmunt Budge', 'Nicolas Flamel', 'Gregory the Smarmy', 'Erica Stainwright', 'Glover Hipworth', 'Laverne de Montmorency', 'null Baruffio', 'Damocles Belby', 'null Mrs Skower', 'Sacharissa Tugwood', 'Tom Riddle']
const elixirsManufacturer = ['Rubens Winikus and Company Inc.', 'Magical Congress of the United States of America', "The Philosopher's Stone", 'Apothecary Department', 'Erica Stainwright', 'Hogwarts Apothecary Department', "Weasleys' Wizard Wheezes", 'Hogwarts Apothecary Dept.', "Madame Glossy's Finest Cleaning Products Ltd.", 'Lord Voldemort']
const characterHouse = ['Gryffindor', 'Slytherin', 'Hufflepuff', 'Ravenclaw']
const mapFilterToIndex  = {difficulty: [0,0], ingredient: [0,1], inventorFullName: [0,2], manufacturer: [0,3],
                            type: [1,0],
                            house: [2,0], status: [2,1]}

import React from "react";
import Select from "react-select";

export class Filter extends React.Component{
    constructor(props) {
        super(props);
    
        this.state = {
          select: [
            [null, null, null, null],
            [null],
            [null, null],
            ]
        };
      }

      setValue = (name,value) => {
        const selectUpdated = this.state.select;
        const [i,j] = mapFilterToIndex[name]
        selectUpdated[i][j] = value;
        this.setState({
          select: selectUpdated
        });
      };

      clearValue = () => {
        this.setState({
          select: [
              [null, null, null, null],
              [null],
              [null, null],
            ]
        });
      }
    
      render() {
       // const { select } = this.state;
       var filters=null
       if(this.props.page == 'Elixirs'){
           const difficultyOption = elixirsDifficulty.sort().map(d => Object.assign({value: d, label: d, color: '#666666', parent: 'difficulty'}))
           const ingredientOption = elixirsIngredient.sort().map(d => Object.assign({value: d, label: d, color: '#666666', parent: 'ingredient'}))
           const inventorOption = elixirsInventor.sort().map(d => Object.assign({value: d, label: d, color: '#666666', parent: 'inventorFullName'}))
           const manufacturerOption = elixirsManufacturer.sort().map(d => Object.assign({value: d, label: d, color: '#666666', parent: 'manufacturer'}))
   
           filters = (<span className="horizontal-align ">
                            <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="difficulty"
                               options={difficultyOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select difficulty:'
                               value={difficultyOption.filter(filterValueCB.bind(this))}/>
                           <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="ingredient"
                               options={ingredientOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select ingredient:'
                               value={ingredientOption.filter(filterValueCB.bind(this))}/>
                           <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="inventorFullName"
                               options={inventorOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select Inventor:'
                               value={inventorOption.filter(filterValueCB.bind(this))}/>
                           <Select
                               className="filter-child "
                               isClearable={true}
                               isSearchable={true}
                               name="manufacturer"
                               options={manufacturerOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select Manufacturer:'
                               value={manufacturerOption.filter(filterValueCB.bind(this))}/>
                               
                       </span>
                       )
       }
       else if(this.props.page == 'Spells'){
           const typeOption = spellType.sort().map(d => Object.assign({}, {value: d, label: d, color: '#666666', parent: 'type'}))
       
           filters = (<span className='filter horizontal-align'>
                            <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="type"
                               options={typeOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select Type:'
                               value={typeOption.filter(filterValueCB.bind(this))}/>
                       </span>
               )
   
       }
       else if(this.props.page == 'Characters'){
           const houseOption = characterHouse.sort().map(d => Object.assign({value: d, label: d, color: '#666666', parent: 'house'})) 
           const statusOption = new Array('students', 'staff').map(d => Object.assign({value: d, label: `${d} in Hogwarts`, color: '#666666', parent: 'status'}))
   
           filters = (<span className='filter horizontal-align'>
                           <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="house"
                               options={houseOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select House:'
                               value={houseOption.filter(filterValueCB.bind(this))}/>
                           <Select
                               className="filter-child"
                               isClearable={true}
                               isSearchable={true}
                               name="status"
                               options={statusOption}
                               onChange={filterChangeHandlerACB.bind(this)}
                               placeholder='Select Status:'
                               value={statusOption.filter(filterValueCB.bind(this))}/>
   
                       </span>
                )
   
       }

        return (
            <div>{filters}</div>
        )

        function filterChangeHandlerACB(evt, action){
          this.setValue(action.name, evt?.value || null);
          if(action.action != 'clear') this.props.onFilterChange(action.name, evt.value)
          else this.props.onFilterDelete(action.name)
        }

        function filterValueCB(option){
          const [i,j] = mapFilterToIndex[option.parent]
          return option.value === this.state.select[i][j];
        }

        
    }
    
}